import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { statsData } from '../mock';

export const Stats = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="py-24 bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {statsData.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="text-center group"
            >
              <motion.div
                whileHover={{ scale: 1.05, y: -5 }}
                transition={{ type: 'spring', stiffness: 300 }}
                className="relative"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-teal-400/20 to-cyan-400/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all" />
                <div className="relative bg-white rounded-3xl p-8 shadow-lg shadow-teal-100/50">
                  <motion.h3
                    initial={{ scale: 0 }}
                    animate={isInView ? { scale: 1 } : { scale: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.2 + 0.3, type: 'spring' }}
                    className="text-6xl md:text-7xl font-bold bg-gradient-to-br from-teal-600 to-cyan-600 bg-clip-text text-transparent mb-4"
                  >
                    {stat.number}
                  </motion.h3>
                  <p className="text-gray-700 text-lg font-medium">{stat.label}</p>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
